import { IBrand } from "./../types/brands";
import { fetchJSON } from "lib/fetch";
import siteConfig from "site-config";

export interface IBrandService {
    fetchBrandsForAssortment: () => Promise<IBrand[]>;
    fetchBrandForMerchant: (merchantId: string) => Promise<any>;
}

export const brand: IBrandService = {
    fetchBrandsForAssortment: (): Promise<IBrand[]> =>
        fetchJSON(`${siteConfig.api}/brands?assortment_brands_only=true`),
    fetchBrandForMerchant: (merchantId: string): Promise<IBrand> =>
        fetchJSON(`${siteConfig.goAPI}/v1/merchants/${merchantId}/brand_portals`).then(({ brand_portals } = {}) => {
            const [{ brand_portal_id } = {} as any] = brand_portals || [];

            if (brand_portal_id) {
                return fetchJSON(`${siteConfig.api}/brand/${brand_portal_id}`);
            }
        }),
};
